export const distict_of_columbia = {
  "11000": "District of Columbia",
  "11001": "District of Columbia",
};
